export default "__VITE_ASSET__GLgOXIwM__"